/**
 * Miscellaneous a11y fixes
 */
(function ($, Drupal) {
  Drupal.behaviors.a11yFixes = {
    attach: function (context, settings) {


      /**
       * Fix double tabbing issue on slick slides.
       */
      $('.slick__slider', context).once('a11yFixes').each(function () {
        const $slider = $(this);

        $slider.on('init reInit afterChange', function () {
          setTimeout(() => {
            $slider.find('.slick-slide').each(function () {
              // Remove tabindex from the outer slide container
              $(this).removeAttr('tabindex');
              $(this).find('a').attr('tabindex', '0');
            });
          }, 10);
        });

        // If Slick is already initialized, trigger the fix immediately
        if ($slider.hasClass('slick-initialized')) {
          $slider.trigger('init');
        }
      });

      /**
       * Makes mobile close a11y compliant with actual button.
       */
      setTimeout(() => {
        const $titleLink = $('.mm-navbar__title');

        if ($titleLink.length && $titleLink.is('a')) {
          const labelText = $titleLink.text().trim() || 'Menu';

          const $wrapper = $('<div class="mm-navbar__title"></div>');
          const $button = $(
            `<button type="button" class="mm-navbar__close" aria-label="Close menu"><span>${labelText}</span></button>`
          );

          $wrapper.append($button);
          $titleLink.replaceWith($wrapper);

          $button.on('click', function () {
            if (window.mmenuApi) {
              window.mmenuApi.close(document.getElementById('off-canvas'));
            }
          });
        }
      }, 300); // Delay may need tuning depending on when Mmenu renders

    }
  };
})(jQuery, Drupal);

